import { render } from "./AbandonedShopperMessage.vue?vue&type=template&id=c82b01b6&scoped=true"
import script from "./AbandonedShopperMessage.vue?vue&type=script&lang=js"
export * from "./AbandonedShopperMessage.vue?vue&type=script&lang=js"

import "./AbandonedShopperMessage.vue?vue&type=style&index=0&id=c82b01b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82b01b6"]])

export default __exports__